import { render, staticRenderFns } from "./CampaignListItemActionButton.vue?vue&type=template&id=826e1fdc&scoped=true"
import script from "./CampaignListItemActionButton.vue?vue&type=script&lang=ts"
export * from "./CampaignListItemActionButton.vue?vue&type=script&lang=ts"
import style0 from "./CampaignListItemActionButton.vue?vue&type=style&index=0&id=826e1fdc&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826e1fdc",
  null
  
)

export default component.exports